import type { Translations } from './en';

export const fr: Translations = {
  nav: {
    services: "Services",
    portfolio: "Portfolio",
    starModel: "Modele Etoile",
    partners: "Partenaires",
    about: "A Propos",
    contact: "Contact",
    getStarted: "Demarrer",
    closeMenu: "Fermer le menu",
    openMenu: "Ouvrir le menu",
  },
  hero: {
    title: "Construire l'Excellence Commerciale de Demain",
    subtitle: "Impresstars orchestre des operations commerciales a haute performance grace a notre systeme innovant Star Model. De l'incorporation a la strategie de croissance, nous sommes votre partenaire en excellence operationnelle.",
    exploreServices: "Explorer les Services",
    learnMore: "En Savoir Plus",
  },
  services: {
    eyebrow: "Ce que nous faisons",
    title: "Nos Services",
    incorporation: {
      title: "Services d'Incorporation",
      description: "Lancez votre entreprise du bon pied avec notre processus d'incorporation simplifie. Creation de LLC, Corp ou a but non lucratif en toute simplicite.",
    },
    aiSolutions: {
      title: "Solutions IA",
      description: "Services d'integration IA personnalises incluant des modeles d'apprentissage automatique, le traitement du langage naturel et des systemes de decision automatises.",
    },
    b2bSolutions: {
      title: "Solutions B2B",
      description: "Services B2B complets incluant le developpement de partenariats, l'optimisation de la chaine d'approvisionnement et l'externalisation de processus commerciaux.",
    },
    marketingStrategy: {
      title: "Strategie Marketing",
      description: "Strategies marketing basees sur les donnees adaptees a vos objectifs commerciaux, incluant l'analyse de marche et la planification de croissance.",
    },
    businessSoftware: {
      title: "Logiciel Commercial",
      description: "Identifiez et implantez les bonnes solutions logicielles pour optimiser vos operations et stimuler votre productivite.",
    },
    brandDesign: {
      title: "Design de Marque",
      description: "Conception professionnelle de logos, developpement d'identite de marque et materiaux marketing qui laissent une impression durable.",
    },
    businessConsulting: {
      title: "Conseil Commercial",
      description: "Orientation strategique pour optimiser vos operations et accelerer la croissance grace a des methodologies eprouvees.",
    },
    ctaTitle: "Pret a Transformer Votre Entreprise?",
    ctaText: "Discutons de la facon dont nos services peuvent vous aider a atteindre vos objectifs.",
    ctaButton: "Demarrer",
  },
  starModel: {
    eyebrow: "Connectes par conception",
    title: "Modeles Etoile",
    description: "Decouvrez notre ecosysteme d'unites commerciales specialisees et la methodologie operationnelle qui les sous-tend.",
    learnHow: "Comment Fonctionne le Modele Etoile",
    captionLeft: "Operations connectees",
    captionRight: "Momentum partage",
    cleaningEdge: {
      title: "Cleaning EDGE",
      status: "Actif",
      description: "Services de nettoyage professionnels reinventes grace a la technologie et a des normes de service exceptionnelles.",
      details: "Cleaning EDGE est une entreprise de nettoyage professionnelle axee sur des services residentiels et commerciaux fiables, incluant le nettoyage post-construction et le detailing automobile, avec des flux de travail numeriques qui facilitent la reservation, la communication et le suivi du service.",
    },
    ozean: {
      title: "Ozean",
      status: "Developpement",
      description: "Une plateforme audio stock offrant des ressources sonores pour les createurs, editeurs, marques et conteurs.",
      details: "Ozean est axe sur l'audio stock cure, aidant les equipes creatives a trouver des pistes et des elements sonores pour la production de contenu.",
    },
    visitWebsite: "Visiter le Site Web",
  },
  testimonials: {
    eyebrow: "Temoignages clients",
    title: "Temoignages de Clients",
    description: "Ne vous fiez pas seulement a notre parole — ecoutez ce que nos clients ont a dire sur leur collaboration avec Impresstars.",
    j94Designs: "Impresstars nous a accompagnes en conseil RH et nous a egalement aides a construire des elements cles de notre site Wix.",
    craftPapi: "Impresstars a developpe un plan marketing pratique pour notre equipe, rendant nos campagnes et priorites beaucoup plus claires.",
    pawStuffs: "Impresstars continue de soutenir notre site Shopify et fournit un support de service continu a mesure que notre boutique grandit.",
  },
  portfolio: {
    eyebrow: "Travail selectionne",
    title: "Notre Portfolio",
    description: "Explorez nos projets recents et nos reussites dans diverses industries et services.",
    filterAll: "Tous",
    filterWebsites: "Sites Web",
    filterApps: "Apps et Outils",
    filterGames: "Jeux",
    filterConsulting: "Conseil",
    production: "Production",
    showcase: "Vitrine",
    viewCaseStudy: "Voir l'Etude de Cas",
    visitSite: "Visiter le Site",
    openProject: "Ouvrir le Projet",
    viewServices: "Voir Nos Services",
    startProject: "Demarrer un Projet",
    filterAllProjects: "Tous les Projets",
    filterRealWorld: "Production",
    filterShowcase: "Vitrine",
    sortFeatured: "En Vedette",
    sortAZ: "Titre: A-Z",
    sortZA: "Titre: Z-A",
    sortLabel: "Trier par:",
    reset: "Reinitialiser",
    showing: "Affichage de",
    of: "sur",
    projects: "projets",
    noProjects: "Aucun projet trouve pour ce filtre pour le moment.",
    visitProjectWebsite: "Visiter le site web du projet",
    catBrandWebsite: "Site Web de Marque",
    catWebDevelopment: "Developpement Web",
    catEcommerceWebsite: "Site E-commerce",
    catBusinessWebsite: "Site Web Commercial",
    catWebsite: "Site Web",
    catJewelleryBrand: "Marque de Joaillerie",
    catWebApp: "App Web",
    catInteractiveApp: "App Interactive",
    catUtilityTool: "Outil Utilitaire",
    cat3DWebSandbox: "Sandbox Web 3D",
    catWebGame: "Jeu Web",
    catGameExperience: "Experience de Jeu",
    catConsultingMarketingPlan: "Conseil et Plan Marketing",
    desc: {
      snouts: "Travail web soutenant la presence de marque en ligne de Snouts.",
      innovaPro: "Livraison de site web pour Innova Pro axee sur une presentation de services claire et de solides performances.",
      pawstuffs: "Presence web e-commerce et support de boutique pour Pawstuffs.",
      cleaningEdge: "Travail de site web et de presence numerique pour Cleaning EDGE.",
      cheesePanic: "Le chat court apres la souris, la souris veut du fromage. Un petit jeu web chaotique.",
      cleaningEdgeApp: "Plateforme self-service axee sur les operations pour les clients et travailleurs de Cleaning EDGE. Testez la demo de developpement avec le mot de passe cleaningEDGE, et assurez-vous de selectionner Legacy Mode.",
      angoloDiamonds: "Travail de developpement web pour Angolo Diamonds.",
      craftPapiGrowth: "Developpement de plan de conseil et marketing pour Craft Papi pour renforcer le positionnement et l'execution de croissance.",
      roboticVoiceClicker: "Experience de clicker activee par la voix avec une interaction ludique de bouton-lezard.",
      cheatCounter: "Jorge a regarde encore une fois la carte du dessus de sa bibliotheque. Quelqu'un devait compter.",
      klondikeSolitaire: "Presentation et interaction d'un jeu web inspire du solitaire classique.",
      universeAdventure: "Concept d'aventure spatiale avec voyages galactiques et exploration basee sur des vaisseaux.",
      interiorDesign3d: "Un sandbox de navigateur Three.js pour importer des modeles 3D et construire des scenes d'interieurs.",
      pavillionJewellery: "Presentation de site web axee sur la marque pour Pavillion Jewellery.",
      hauntedGalleria: "Un site vitrine immersif au theme sombre pour une experience de galerie hantee avec des visuels atmospheriques et des animations inquietantes.",
    },
  },
  partners: {
    eyebrow: "Technologie Fiable",
    title: "Outils que Nous Utilisons et Recommandons",
    description: "Ce sont des plateformes avec lesquelles nous travaillons activement et que nous recommandons a nos clients. Si vous vous inscrivez via nos liens, nous pouvons gagner une recommandation — sans cout supplementaire pour vous.",
    teaserEyebrow: "Technologie Fiable",
    teaserTitle: "Outils que Nous Recommandons",
    seeAllPartners: "Voir Tous les Partenaires",
    getStarted: "Demarrer",
    ctaTitle: "Besoin d'Aide pour Choisir le Bon Stack?",
    ctaText: "Nous evalueons, implementons et integrons des outils dans votre flux de travail. Laissez-nous gerer la technologie pour que vous puissiez vous concentrer sur votre entreprise.",
    ctaButton: "Parlez-nous",
    disclaimer: "Certains liens sur cette page sont des liens de recommandation. Impresstars peut gagner une commission si vous vous inscrivez — sans cout supplementaire pour vous.",
    catProductivity: "Productivite",
    catAIVoice: "IA et Voix",
    catBusinessPhone: "Telephone Commercial",
    catAIWebBuilder: "Constructeur Web IA",
  },
  about: {
    eyebrow: "Notre vocation",
    title: "A Propos d'Impresstars",
    p1: "Chez Impresstars, nous croyons en la transformation des operations commerciales grace a l'innovation et a l'excellence. Notre mission est d'aider les entreprises a atteindre leur plein potentiel en implementant des solutions de pointe et des methodologies eprouvees.",
    p2: "Fondes sur les principes d'excellence operationnelle et de croissance durable, nous avons developpe notre systeme unique Star Model qui a aide de nombreuses entreprises a atteindre un succes remarquable.",
  },
  clients: {
    title: "Nos Clients",
    description: "Nous sommes fiers de travailler avec ces organisations et de les aider a grandir grace a nos services et notre support dedie.",
  },
  techPlatforms: {
    title: "Technologies et Plateformes que Nous Supportons",
    description: "Nous pouvons aider avec l'implementation, l'optimisation ou le support sur ces outils et plateformes.",
    catEcommerce: "E-commerce et Sites Web",
    catAI: "IA et Automatisation",
    catMarketing: "Marketing et Croissance",
    catCloud: "Cloud et Infrastructure",
    catCreative: "Production Creative et de Marque",
    focusEcommerce: "Competence principale: lancer et soutenir des boutiques et sites web axes sur la conversion.",
    focusAI: "Competence principale: adoption pratique de l'IA et automatisation des flux de travail pour les equipes en croissance.",
    focusMarketing: "Competence principale: suivi des performances, execution de campagnes et SEO fondamental.",
    focusCloud: "Competence principale: deploiement fiable et support d'environnement pour les operations web modernes.",
    focusCreative: "Competence principale: actifs d'execution de marque qui soutiennent le marketing et la narration produit.",
  },
  contact: {
    title: "Contactez-nous",
    description: "Pret a transformer votre entreprise? Envoyez-nous un message et nous vous repondrons dans les 24 heures.",
    name: "Nom",
    namePlaceholder: "Votre nom",
    email: "Email",
    emailPlaceholder: "votre@email.com",
    reason: "Motif de Contact",
    reasonPlaceholder: "Selectionnez un motif",
    message: "Message",
    messagePlaceholder: "Comment pouvons-nous vous aider?",
    sending: "Envoi...",
    send: "Envoyer le Message",
    successTitle: "Message Envoye!",
    successText: "Merci de nous avoir contactes. Nous vous repondrons bientot.",
    sendAnother: "Envoyer un Autre Message",
    recaptchaError: "Veuillez completer la verification reCAPTCHA.",
    submitError: "L'envoi a echoue. Reessayez ou envoyez-nous un email directement.",
    reasons: {
      incorporationServices: "Services d'Incorporation",
      aiSolutions: "Solutions IA",
      b2bSolutions: "Solutions B2B",
      marketingStrategy: "Strategie Marketing",
      businessSoftware: "Logiciel Commercial",
      brandDesign: "Design de Marque",
      businessConsulting: "Conseil Commercial",
      websiteDevelopment: "Developpement Web",
      websiteSupport: "Support / Maintenance Web",
      ecommerceSupport: "Support E-commerce",
      generalQuestion: "Question Generale",
      partnership: "Opportunite de Partenariat",
    },
  },
  footer: {
    tagline: "Transformer les operations commerciales grace a l'innovation et a l'excellence.",
    quickLinks: "Liens Rapides",
    starModels: "Modeles Etoile",
    legal: "Legal",
    termsConditions: "Termes et Conditions",
    privacyPolicy: "Politique de Confidentialite",
    contactTitle: "Contact",
    city: "London, ON",
    country: "Canada",
    rightsReserved: "Impresstars. Tous droits reserves.",
    notALawFirm: "Impresstars n'est pas un cabinet d'avocats et ne fournit pas de conseils juridiques.",
  },
  notFound: {
    title: "Page Introuvable",
    metaDescription: "La page que vous recherchez n'existe pas ou a ete deplacee.",
    heading: "Page Introuvable",
    text: "La page que vous recherchez n'existe pas ou a peut-etre ete deplacee. Remettons-vous sur le bon chemin.",
    backHome: "Retour a l'Accueil",
    contactUs: "Nous Contacter",
    portfolio: "Portfolio",
    services: "Services",
  },
  caseStudy: {
    notFound: "Etude de Cas Introuvable",
    returnHome: "Retour a l'Accueil",
    backToPortfolio: "Retour au Portfolio",
    client: "Client:",
    challenge: "Le Defi",
    solution: "Notre Solution",
    keyResults: "Resultats Cles",
    technologiesUsed: "Technologies Utilisees",
    visitProject: "Visiter le Projet",
    items: {
      cleaningEdgePlatform: {
        title: "Plateforme Cleaning EDGE",
        category: "Developpement Web",
        client: "Cleaning EDGE",
        description: "Une plateforme numerique complete pour gerer les services de nettoyage, incluant la planification, la gestion d'equipes et les retours clients.",
        challenge: "Le client avait besoin d'une solution evolutive pour gerer ses operations de service de nettoyage en croissance, traiter les reservations clients et optimiser la planification d'equipes sur plusieurs sites.",
        solution: "Nous avons developpe une plateforme web personnalisee qui integre la gestion de reservations, la planification d'equipes et le suivi en temps reel. La solution inclut un portail client, un tableau de bord admin et une interface adaptee aux mobiles pour les equipes de nettoyage.",
        results: [
          "Reduction des conflits de planification de 95%",
          "Augmentation de la satisfaction client a 98%",
          "Amelioration de l'efficacite de l'equipe de 40%",
          "Expansion vers 3 nouveaux sites",
        ],
      },
      aiAnalyticsDashboard: {
        title: "Tableau de Bord Analytique IA",
        category: "Solutions IA",
        client: "TechVision Inc.",
        description: "Tableau de bord analytique personnalise utilisant l'apprentissage automatique pour predire les tendances commerciales et optimiser les operations.",
        challenge: "Le client avait du mal a donner un sens a sa vaste collecte de donnees et avait besoin d'insights predictifs pour prendre de meilleures decisions commerciales.",
        solution: "Nous avons implante un systeme d'apprentissage automatique qui analyse les donnees historiques, predit les tendances et fournit des insights actionnables via une interface de tableau de bord intuitif.",
        results: [
          "Augmentation de la precision des predictions de 85%",
          "Reduction du temps de decision de 60%",
          "Generation de 2M$ d'economies",
          "Amelioration de la gestion des stocks de 45%",
        ],
      },
      globalMarketingCampaign: {
        title: "Campagne Marketing Globale",
        category: "Strategie Marketing",
        client: "Global Solutions Ltd",
        description: "Strategie de marketing digital complete qui a augmente la presence commerciale du client sur trois continents.",
        challenge: "Le client devait etendre sa presence commerciale mondialement tout en maintenant un message de marque coherent et un engagement dans differents contextes culturels.",
        solution: "Nous avons developpe une strategie marketing multicanale avec du contenu localise, de la publicite ciblee et une adaptation culturelle des materiaux marketing.",
        results: [
          "Atteint plus de 2M de nouveaux clients potentiels",
          "Augmentation des ventes mondiales de 150%",
          "Amelioration de la reconnaissance de marque de 80%",
          "Genere 300% de ROI sur les depenses marketing",
        ],
      },
      hauntedGalleria: {
        title: "Haunted Galleria",
        category: "Design et Developpement Web",
        client: "Haunted Galleria",
        description: "Un site vitrine immersif au theme sombre pour une experience de galerie hantee — melant visuels atmospheriques, animations inquietantes et typographie audacieuse.",
        challenge: "Le client avait besoin d'une presence web correspondant a la nature dramatique et mysterieuse de son concept de galerie hantee.",
        solution: "Nous avons cree un site entierement personnalise avec une esthetique sombre ambiante, des effets de parallaxe et une typographie inspiree de l'horreur pour creer du suspense.",
        results: [
          "Identite de marque distinctive sur un marche de niche",
          "UX immersive qui maintient les visiteurs engages plus longtemps",
          "Entierement responsive sur tous les appareils",
          "Optimise pour des temps de chargement rapides malgre des effets visuels riches",
        ],
      },
    },
  },
  servicePages: {
    incorporation: {
      title: "Services d'Incorporation",
      metaDescription: "Lancez votre voyage commercial en toute confiance. Nos services d'incorporation fournissent une base solide pour le futur succes de votre entreprise.",
      intro: "Lancez votre voyage commercial en toute confiance. Nos services d'incorporation fournissent une base solide pour le futur succes de votre entreprise.",
      disclaimer: "Avis: Impresstars n'est pas un cabinet d'avocats et ne fournit pas de conseils juridiques. Nous recommandons de consulter un avocat qualifie pour des conseils juridiques.",
      structureOptions: "Options de Structure d'Entreprise",
      structureItems: [
        "Societe a Responsabilite Limitee (LLC)",
        "Corporation (C-Corp, S-Corp)",
        "Organisation a But Non Lucratif",
        "Formations de Partenariats",
      ],
      included: "Ce qui est Inclus",
      includedItems: [
        "Recherche de Nom Commercial",
        "Statuts d'Incorporation",
        "Enregistrement EIN",
        "Convention Operationnelle",
      ],
      ctaTitle: "Pret a Vous Incorporer?",
      ctaText: "Discutons de la meilleure structure pour votre entreprise et mettons-vous sur la bonne voie.",
      ctaButton: "Planifier une Consultation",
    },
    aiSolutions: {
      title: "Solutions IA",
      metaDescription: "Transformez votre entreprise avec des solutions d'intelligence artificielle de pointe adaptees a vos besoins specifiques.",
      intro: "Transformez votre entreprise avec des solutions d'intelligence artificielle de pointe adaptees a vos besoins specifiques.",
      servicesTitle: "Services IA",
      servicesItems: [
        "Modeles d'Apprentissage Automatique",
        "Traitement du Langage Naturel",
        "Solutions de Vision par Ordinateur",
        "Analyse Predictive",
      ],
      implAreas: "Domaines d'Implementation",
      implItems: [
        "Automatisation du Service Client",
        "Analyse de Donnees et Insights",
        "Optimisation des Processus",
        "Systemes d'Aide a la Decision",
      ],
      ctaTitle: "Pret a Implementer l'IA?",
      ctaText: "Explorons comment l'IA peut revolutionner vos operations commerciales et stimuler la croissance.",
      ctaButton: "Demarrer",
    },
    b2bSolutions: {
      title: "Solutions B2B",
      metaDescription: "Optimisez vos operations business-to-business avec nos solutions completes conques pour les entreprises modernes.",
      intro: "Optimisez vos operations business-to-business avec nos solutions completes conques pour les entreprises modernes.",
      coreServices: "Services Principaux",
      coreServicesItems: [
        "Optimisation de la Chaine d'Approvisionnement",
        "Developpement de Partenariats",
        "Externalisation de Processus",
        "Planification Strategique",
      ],
      benefits: "Avantages",
      benefitsItems: [
        "Efficacite Accentuee",
        "Reduction des Cout",
        "Expansion du Marche",
        "Croissance des Revenus",
      ],
      ctaTitle: "Transformez Vos Operations B2B",
      ctaText: "Optimisons vos relations et processus commerciaux pour une efficacite maximale.",
      ctaButton: "Contactez-nous",
    },
    marketingStrategy: {
      title: "Strategie Marketing",
      metaDescription: "Developpez une strategie marketing puissante qui stimule la croissance et connecte avec votre public cible.",
      intro: "Developpez une strategie marketing puissante qui stimule la croissance et connecte avec votre public cible.",
      strategyComponents: "Composantes de Strategie",
      strategyItems: [
        "Analyse de Marche",
        "Recherche sur les Concurrents",
        "Profilage du Public Cible",
        "Strategie de Canaux",
      ],
      deliverables: "Livrables",
      deliverablesItems: [
        "Plan Marketing",
        "Strategie de Contenu",
        "Feuille de Route de Campagnes",
        "Projections de ROI",
      ],
      ctaTitle: "Pret a Croitre?",
      ctaText: "Creons une strategie marketing qui propulse votre entreprise au niveau superieur.",
      ctaButton: "Commencer la Planification",
    },
    brandDesign: {
      title: "Design de Marque",
      metaDescription: "Creez une identite de marque memorable qui resone avec votre public et se demarque sur le marche.",
      intro: "Creez une identite de marque memorable qui resone avec votre public et se demarque sur le marche.",
      designServices: "Services de Design",
      designItems: [
        "Conception de Logo",
        "Guides de Marque",
        "Identite Visuelle",
        "Materiaux Marketing",
      ],
      deliverables: "Livrables",
      deliverablesItems: [
        "Guide de Style de Marque",
        "Pack de Logos",
        "Palette de Couleurs",
        "Systeme Typographique",
      ],
      ctaTitle: "Pret pour un Nouveau Look?",
      ctaText: "Creons une identite de marque qui capture votre vision et connecte avec votre public.",
      ctaButton: "Demarrer le Processus de Design",
    },
    businessConsulting: {
      title: "Conseil Commercial",
      metaDescription: "Obtenez des conseils d'experts pour optimiser vos operations et accelerer la croissance commerciale grace a des methodologies eprouvees.",
      intro: "Obtenez des conseils d'experts pour optimiser vos operations et accelerer la croissance commerciale grace a des methodologies eprouvees.",
      consultingAreas: "Domaines de Conseil",
      consultingItems: [
        "Planification Strategique",
        "Optimisation des Operations",
        "Analyse Financiere",
        "Strategie de Croissance",
      ],
      benefits: "Avantages",
      benefitsItems: [
        "Efficacite Amelioree",
        "Reduction des Cout",
        "Croissance des Revenus",
        "Meilleure Prise de Decision",
      ],
      ctaTitle: "Pret a Optimiser?",
      ctaText: "Analysous votre entreprise et creons une feuille de route pour une croissance durable.",
      ctaButton: "Reserver une Consultation",
    },
    businessSoftware: {
      title: "Solutions Logicielles Commerciales",
      metaDescription: "Transformez vos operations commerciales avec des solutions logicielles soigneusement selectionnees et implantees qui rationalisent les processus et stimulent l'efficacite.",
      intro: "Transformez vos operations commerciales avec des solutions logicielles soigneusement selectionnees et implantees qui rationalisent les processus et stimulent l'efficacite.",
      ourApproach: "Notre Approche",
      approachItems: [
        "Analyse des Processus Commerciaux",
        "Collecte des Exigences Logicielles",
        "Evaluation et Selection de Solutions",
        "Implementation et Integration",
      ],
      solutionAreas: "Domaines de Solution",
      solutionItems: [
        "Systemes ERP",
        "Plateformes CRM",
        "Outils de Gestion de Projet",
        "Developpement de Logiciel Personnalise",
      ],
      ctaTitle: "Pret a Optimiser Vos Operations?",
      ctaText: "Identifions les solutions logicielles parfaites pour transformer vos processus commerciaux.",
      ctaButton: "Planifier une Consultation",
    },
  },
  seo: {
    homeTitle: "Construire l'Excellence Commerciale de Demain",
    homeDescription: "Impresstars orchestre des operations commerciales a haute performance grace a notre systeme innovant Star Model. De l'incorporation a la strategie de croissance, nous sommes votre partenaire en excellence operationnelle.",
    portfolioTitle: "Portfolio",
    portfolioDescription: "Explorez notre collection complete de projets reussis et d'etudes de cas dans diverses industries.",
    partnersTitle: "Outils et Partenaires Recommandes",
    partnersDescription: "Outils et plateformes qu'Impresstars utilise et recommande pour les clients. Demarrez avec une technologie de premiere classe via nos liens de recommandation.",
  },
  languageSwitcher: {
    label: "Langue",
  },
};
